import React from "react";
import YoutubeEmbed from "./youtubeEmbed";

export const Video = ({ embedId }) => {
  return (
    <div className="portfolio-item">
      <div className="hover-bg">
        {" "}
        {/* <a href={largeImage} title={title} data-lightbox-gallery="gallery1"> */}
        {/* <a title={title} data-lightbox-gallery="gallery1"> */}
          <div className="hover-text">
            {/* <h4>{title}</h4> */}
          </div>
            <YoutubeEmbed embedId={embedId} />
        {/* </a>{" "} */}
      </div>
    </div>
  );
};
